'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface VoiceLoginProps {
  onVoiceActivate: () => void;
  isActive: boolean;
}

const VoiceLogin = ({ onVoiceActivate, isActive }: VoiceLoginProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [isListening, setIsListening] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (isActive) {
      setIsListening(true);
      const timer = setTimeout(() => setIsListening(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isActive]);

  if (!isHydrated) {
    return (
      <div className="w-full max-w-md mx-auto mt-6">
        <div className="h-12 bg-muted rounded animate-pulse"></div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-md mx-auto mt-6">
      <button
        onClick={onVoiceActivate}
        className={`w-full flex items-center justify-center gap-3 px-4 py-3 rounded-md font-medium text-sm transition-smooth ${
          isActive
            ? 'bg-accent text-accent-foreground shadow-elevation-md'
            : 'bg-card border border-border hover:bg-muted hover:shadow-elevation-sm'
        }`}
      >
        <div className="relative">
          <Icon 
            name="MicrophoneIcon" 
            size={20} 
            className={isListening ? 'animate-pulse-subtle' : ''}
          />
          {isListening && (
            <span className="absolute -top-1 -right-1 flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-error opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-error"></span>
            </span>
          )}
        </div>
        <span>{isActive ? 'Listening...' : 'Login with Voice'}</span>
      </button>
      
      {isActive && (
        <p className="mt-2 text-xs text-center text-muted-foreground">
          Say "Login with [email/phone] and password"
        </p>
      )}
    </div>
  );
};

export default VoiceLogin;